<div class="comparables-workplace-container">
  <div class="workplace-wrapper-outer">
    <div class="workplace-wrapper-inner">
      <div class="comparables-tabStrip-content">
        <comparables-properties-workspace [workplace]="this" [tabElement]="tabConfig[0]" id="tabProperty" [hidden]="selectedTab !== '#tabProperty'"></comparables-properties-workspace>
        <comparables-valuations-workspace [workplace]="this" [tabElement]="tabConfig[1]" id="tabValuation" [hidden]="selectedTab !== '#tabValuation'"></comparables-valuations-workspace>
        <comparables-leases-workspace [workplace]="this" [tabElement]="tabConfig[2]" id="tabLeases" [hidden]="selectedTab !== '#tabLeases'"></comparables-leases-workspace>
      </div>
    </div>
  </div>
</div>
